import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getMyData } from '../services/userService';

export const UserContext = createContext(null);

export const UserProvider = ({ children }) => {

  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  });

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('access', userData.access);
    localStorage.setItem('refresh', userData.refresh);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
  };

  /**
   * Aggiorna il profilo utente chiamando GET /users/myself/ e sincronizza
   * sia lo state React che localStorage. Mantiene i token JWT invariati.
   * Usato al mount per risolvere dati stale (es. managed_contests) e può
   * essere chiamato esplicitamente dopo operazioni che cambiano il profilo.
   */
  const refreshUser = useCallback(async () => {
    try {
      const freshData = await getMyData();
      setUser(prev => {
        if (!prev) return prev;
        const merged = { ...prev, ...freshData };
        localStorage.setItem('user', JSON.stringify(merged));
        return merged;
      });
    } catch {
      // Se la chiamata fallisce (es. token scaduto) lasciamo il dato esistente;
      // l'interceptor di apiClient gestirà il refresh del token separatamente.
    }
  }, []);

  // Al mount, se l'utente è già autenticato, aggiorna i dati dal server
  // per garantire che campi come managed_contests siano sempre freschi.
  useEffect(() => {
    if (localStorage.getItem('access')) {
      refreshUser();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <UserContext.Provider value={{ user, login, logout, refreshUser }}>
      {children}
    </UserContext.Provider>
  );
};

export function useUser() {
  const context = useContext(UserContext);
  if (!context) throw new Error('useUser deve essere usato dentro <UserProvider>');
  return context;
}
